import { Button, FlexWrapper, FontIcon, Text } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import { getBaseSubscription } from '@intigral/utils/lib/user';
import { getUserInfo } from '../../../../utils/user';
import { __ } from '../../../../translations';
import formatter from '../../../../helpers/formatter';
import { Modal } from '../../../../components/ui/Modal';

const RenewalDueNotificationPopup = ({ isOpen, closePopup }) => {
    const userInfo = getUserInfo();
    const tierStatus = userInfo?.tierStatus || getBaseSubscription(userInfo);

    return (
        <Modal useFlexLayout={false} open={isOpen} onOpenChange={closePopup} closePlacement="end" widthSet="medium">
            <FlexWrapper flexDirection="column" gap={{ default: '2x', md: '3x' }}>
                <FontIcon name="info" size="size60" md="size60" />
                <Text as="h3" variant="h3" margin="0" size={{ default: '22', md: '28' }}>
                    {__('gamification_renewal_due_popup_title')}
                </Text>
                <Text as="p" margin="0" color="gray" alignment="center">
                    {__(`gamification_renewal_due_popup_desc`).replace(
                        '{renewalDate}',
                        formatter.formatDate(tierStatus?.nextRenewalDate)
                    )}
                </Text>
                <FlexWrapper flexDirection="row" gap={{ default: '2x', md: '3x' }} paddingTop={{ default: '2x' }}>
                    <FlexChild alignSelf="center" placement={'center'}>
                        <Button onClick={closePopup} fullWidth>
                            {__('gamification_renewal_due_popup_confirm_cta')}
                        </Button>
                    </FlexChild>
                </FlexWrapper>
            </FlexWrapper>
        </Modal>
    );
};

export default RenewalDueNotificationPopup;
